import { EquipmentDeficiencyDocument } from '../EquipmentDeficiency/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  EquipmentDeficiencyLogDocument,
  equipmentDeficiencyLogPullQueryBuilder,
  equipmentDeficiencyLogPushQueryBuilder,
} from './queryBuilder';

export function equipmentDeficiencyLogFamilyMember(
  configBuilder: ConfigBuilder,
  equipmentDeficiency: FamilyMember<EquipmentDeficiencyDocument>,
): FamilyMember<EquipmentDeficiencyLogDocument> {
  const syncConfig = configBuilder<EquipmentDeficiencyLogDocument>(
    RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY_LOG,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, equipmentDeficiencyLogPullQueryBuilder);
  push(syncConfig, equipmentDeficiencyLogPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY_LOG, replicationState, [
    equipmentDeficiency,
  ]);
}
